import { gql } from '@apollo/client';

export const getBasicUserInfo = gql`
  query getBasicUserInfo($id: ID!) {
    core {
      getUserDetails(userId: $id) {
        user {
          firstName
          middleName
          lastName
        }
      }
    }
  }
`;
